import * as React from 'react';
import { useErrorLog } from '@core-front/error-provider';
export const defaultContext = {
    get: key => {
        if (typeof process === 'undefined' || (process.env.NODE_ENV !== 'test' && process.env.STYLEGUIDE === 'false')) {
            console.error('LabelProvider missing! Application must be wrapped with <LabelProvider>');
        }
        return key;
    },
};
export const LabelContext = React.createContext(defaultContext);
export const replaceParams = (label, params) => {
    return Object.keys(params).reduce((text, key) => text.replace(`$\{${key}}`, params[key]), label);
};
const LabelProvider = (props) => {
    const { labels, children } = props;
    const { log } = useErrorLog();
    const get = (key, params) => {
        const label = labels[key];
        if (!label) {
            log(`Label missing for key "${key}".`);
            return key;
        }
        if (params) {
            return replaceParams(label, params);
        }
        return label;
    };
    return React.createElement(LabelContext.Provider, { value: { get } }, children);
};
export default LabelProvider;
